import React, { Component } from "react";

export default class AdminLink extends Component {
  render() {
    const { message } = this.props;
    return (
      <div className="admin-link">
        <div className="card">
          <div className="title">
            <span>
              {message ||
                "Retrouvez cette fonctionnalité dans le nouveau backoffice :"}
            </span>
            <a
              className="link"
              href="https://admin.mon-sejour-en-montagne.com/"
            >
              https://admin.mon-sejour-en-montagne.com/
            </a>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/AdminLink.js